import * as React from "react";
import {
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "height": "100%",

      // "& .MuiTableRow-root:nth-child(odd)": {
      //   background: theme.customPaper.background.cardBackgroundTable,
      // },

      "& .MuiTableCell-alignCenter": {
        color: theme.palette.text.primary,
      },

      "& .MuiTableCell-stickyHeader": {
        backgroundColor: "#1D212A",
        color: theme.palette.common.white,
      },
    },
  })
);

type SimpleTableProps = {
  header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[][];
  loading?: boolean;
};

const loadingState = new Array(12).fill({});

function SimpleTable({ header, rows, loading = false }: SimpleTableProps) {
  const classes = useStyles();

  return (
    <TableContainer className={classes.root} component={Paper}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {header.map((h, idx) => (
              <TableCell align="center" key={`header_${idx}`}>
                <strong>{h}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {!loading &&
            rows.map((row, idx) => (
              <TableRow key={`row_${idx}`}>
                {row.map((cell, idy) => (
                  <TableCell align="center" key={`row_${idx}_col_${idy}`}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}

          {loading &&
            loadingState.map((_, idx) => (
              <TableRow key={`loading_row_${idx}`}>
                <TableCell colSpan={header.length}>
                  <Skeleton />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SimpleTable;
